import { memo } from 'react';
import type { ElementType } from 'react';

import classNames from 'classnames';

import type { PolymorphicPropsWithRef } from '@/shared/types';
import type { OpdsStyleProps } from '@/shared/ui/Box';
import { Box } from '@/shared/ui/Box';

import styles from './UnstyledButton.module.css';

export type UnstyledButtonProps<C extends ElementType = 'button'> = OpdsStyleProps &
  PolymorphicPropsWithRef<C, unknown>;

const UnstyledButton = <C extends ElementType = 'button'>(props: UnstyledButtonProps<C>) => {
  const { className, children, as = 'button', ...rest } = props;

  return (
    <Box as={as as ElementType} className={classNames(className, styles.button)} type="button" {...rest}>
      {children}
    </Box>
  );
};

export default memo(UnstyledButton) as typeof UnstyledButton;
